// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6b8eaee1","703":"1265e39b","787":"9622ca37"}[chunkId] + ".chunk.js";
};